import React from 'react';
import Hero from '../components/Sections/Hero';
import PopularPrograms from '../components/Sections/PopularPrograms';
import { Problem, HowItWorks, EcosystemSection, Vision } from '../components/Sections/Sections';
import Courses from '../components/Sections/Courses';
import { ApplySection } from '../components/Sections/Forms';
import TestimonialsSection from '../components/Sections/Testimonials';
import PartnersMarquee from '../components/Sections/PartnersMarquee';
import '../components/Sections/Sections.css';
import '../components/Sections/Forms.css';

// Partner logos
import codeplateau from '../assets/partners/codeplateau-tieup.png';
import BMC from '../assets/partners/BMC-Software-tieup.png';
import Cybage from '../assets/partners/Cybage-tieup.png';
import Deloitte from '../assets/partners/Deloitte-tieup.png';
import Persistant from '../assets/partners/persistant-tieup.png';
import phoenix from '../assets/partners/Phoenix-tieup.png';
import pradysis from '../assets/partners/pradysis-tieup.png';
import radical from '../assets/partners/radical-tieup.png';
import redhat from '../assets/partners/redhat-tieup.png';
import tejit from '../assets/partners/tejit-tieup.png';
import thinkitive from '../assets/partners/thinkitive-tieup.png';
import wenexa from '../assets/partners/wenexa-tieup.png';
import Zenture from '../assets/partners/Zenture-tieup.png';

const PARTNERS = [
  { name: "CodePlateau", logo: codeplateau },
  { name: "BMC Software", logo: BMC },
  { name: "Pradysis", logo: pradysis },
  { name: "Cybage", logo: Cybage },
  { name: "Red Hat", logo: redhat },
  { name: "Deloitte", logo: Deloitte },
  { name: "Persistent", logo: Persistant },
  { name: "Phoenix", logo: phoenix },
  { name: "Radical", logo: radical },
  { name: "Tejit", logo: tejit },
  { name: "Thinkitive", logo: thinkitive },
  { name: "WeNexa", logo: wenexa },
  { name: "Zenture", logo: Zenture },
];

const Home = () => {
  return (
    <>
      <Hero />
      <PopularPrograms />

      {/* ── Partners Strip (fixed label + scrolling logos) ── */}
      <div className="partners-strip">
        {/* Fixed text */}
        <div className="partners-label">
          <span>Our Partners</span>
        </div>

        {/* Scrolling logos only */}
        <div className="partners-marquee">
          <div className="partners-track">
            {[...PARTNERS, ...PARTNERS].map((p, i) => (
              <div key={`${p.name}-${i}`} className="partner-item">
                <img src={p.logo} alt={p.name} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Rest of sections */}
      <Courses />
      {/* <PartnersMarquee /> */}
      <Problem />
      <HowItWorks />
      <EcosystemSection />
      <Vision />
      <ApplySection />
      <TestimonialsSection />
    </>
  );
};

export default Home;